module.exports = __webpack_public_path__ + "media/images/marketing-bg-c22201375a838e2c799054df25faa919.png";